import { createSelector } from "reselect";
import { patientEducationSelectors } from "./Slice";
export const allEducationLibrarySelector = (state) => patientEducationSelectors.selectAll(state.patientEducation);
export const patientEducationByIdSelector = (state, id) => patientEducationSelectors.selectById(state.patientEducation, id);
export const patientEducationByMimeTypeSelector = (mimeType) => (state) => createSelector(patientEducationSelectors.selectAll, (libraries) => {
    return libraries.filter((library) => library.itemMimeType === mimeType);
})(state.patientEducation);
